import { getSentryCookieContext } from "./sentry-cookie-context.js";
import { addSentryEventUrl, removeSentryRouteTags } from "./sentry-event-context.js";
import { normalizeRouteTemplate } from "./normalize-route-template.js";
import { resolveSentryBookingRouteContext } from "./sentry-booking-route-context.js";
import { resolveSentryRouteTemplate } from "./resolve-sentry-route-template.js";
import { setSentryTag } from "./set-sentry-tag.js";

type SentryEvent = {
  request?: object;
  tags?: Record<string, unknown>;
  user?: Record<string, unknown>;
};

export const processSentryEvent = <T extends SentryEvent>(
  event: T,
  {
    sessionTraceId,
    url,
    pathname,
    search,
  }: {
    sessionTraceId: string;
    url: string;
    pathname: string;
    search: string;
  },
): T => {
  const { tags, user } = getSentryCookieContext();

  addSentryEventUrl(event, url);
  event.tags = { ...event.tags, ...tags, sessionTraceId };

  const routeTags = resolveSentryBookingRouteContext({ pathname, search });
  const routeTemplate = normalizeRouteTemplate(resolveSentryRouteTemplate(pathname));
  setSentryTag("routeTemplate", routeTemplate);
  removeSentryRouteTags(event);
  event.tags = {
    ...event.tags,
    ...(routeTags.hotelId !== undefined ? { hotelId: String(routeTags.hotelId) } : {}),
    ...(routeTags.checkoutId ? { checkoutId: routeTags.checkoutId } : {}),
    ...(routeTags.dealKey ? { dealKey: routeTags.dealKey } : {}),
    routeTemplate,
  };

  if (user) {
    event.user = { ...event.user, ...user };
  }

  return event;
};
